module.exports = __webpack_public_path__ + "img/ring_g_o_null_0@2x.1ccb46c9.png";